<template>
  <Teleport to="body">
    <ul
      v-if="open"
      class="mention-suggest"
      :style="menuStyle"
      @mousedown.prevent
    >
      <li v-if="!items.length" class="mention-suggest__empty">No users found</li>
      <li
        v-for="(item, index) in items"
        :key="item.userId"
        class="mention-suggest__item"
        :class="{ 'is-active': index === activeIndex }"
        @mousedown.prevent="$emit('pick', item)"
        @mouseenter="$emit('hover', index)"
      >
        <span class="mention-suggest__name">{{ item.label }}</span>
        <span v-if="item.username" class="mention-suggest__meta">{{ item.username }}</span>
      </li>
    </ul>
  </Teleport>
</template>

<script>
export default {
  name: "MentionSuggest",
  props: {
    open: { type: Boolean, default: false },
    items: { type: Array, default: () => [] },
    activeIndex: { type: Number, default: 0 },
    anchor: { type: Object, default: null },
  },
  emits: ["pick", "hover"],
  computed: {
    menuStyle() {
      const box = this.anchor || {};
      return {
        top: `${Number(box.top || 0)}px`,
        left: `${Number(box.left || 0)}px`,
        width: `${Number(box.width || 240)}px`,
      };
    },
  },
};
</script>

<style>
.mention-suggest {
  position: fixed;
  z-index: 4000;
  margin: 0;
  padding: 0.25rem 0;
  list-style: none;
  max-height: 220px;
  overflow-y: auto;
  background: #fff;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  box-shadow: 0 10px 28px rgba(52, 71, 103, 0.16);
}

.mention-suggest__item,
.mention-suggest__empty {
  display: flex;
  flex-direction: column;
  gap: 0.05rem;
  padding: 0.4rem 0.7rem;
  font-size: 0.78rem;
  line-height: 1.25;
}

.mention-suggest__empty {
  color: #8392ab;
}

.mention-suggest__item {
  cursor: pointer;
  color: #344767;
}

.mention-suggest__item.is-active,
.mention-suggest__item:hover {
  background: #f3efff;
}

.mention-suggest__name {
  font-weight: 600;
}

.mention-suggest__meta {
  font-size: 0.68rem;
  color: #8392ab;
}

.mention-chip {
  display: inline;
  color: #5e72e4;
  font-weight: 700;
}
</style>
